import {SpacingProperties} from './flex-child.interfaces';

export const buildSpacingString = (spacing: SpacingProperties): string => {
  return (spacing.top ? spacing.top : 0) + ' ' + (spacing.right ? spacing.right : 0) + ' ' + (spacing.bottom ? spacing.bottom : 0) + ' ' + (spacing.left ? spacing.left : 0);
};
